import { render, staticRenderFns } from "./SalarieDetailList.vue?vue&type=template&id=f69c45f4&scoped=true"
import script from "./SalarieDetailList.vue?vue&type=script&lang=js"
export * from "./SalarieDetailList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f69c45f4",
  null
  
)

export default component.exports